import React, { useContext, useEffect, useRef, useState } from 'react';
import { Chat } from 'stream-chat-react';
import 'stream-chat-react/dist/css/v2/index.css';
import { AuthContext } from '../contexts/AuthProvider';
import {
  streamClient,
  connectStreamUser,
  disconnectStreamUser,
  subscribeToStreamConnection,
  getStreamConnectionState,
} from './streamClient';
import { tokenProviderFor } from './tokens';

// eslint-disable-next-line react/prop-types
export const StreamProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const [state, setState] = useState(() => getStreamConnectionState());

  useEffect(() => subscribeToStreamConnection(setState), []);

  useEffect(() => {
    if (!currentUser?.uid || !streamClient) return undefined;
    const uid = currentUser.uid;
    const associate = currentUser.associate?.[currentUser.associateId]?.user;
    const name = associate
      ? `${associate.firstName || ''} ${associate.lastName || ''}`.trim()
      : (currentUser.profile?.firstName || currentUser.email || currentUser.uid);
    const image = associate?.profilePictureURL || currentUser.profile?.profilePictureURL;
    connectStreamUser({ id: uid, name, image }, tokenProviderFor(uid)).catch((e) => {
      console.error('[stream] connect failed', e);
    });
    return undefined;
  }, [currentUser?.uid, currentUser?.associateId]);

  const prevUidRef = useRef(currentUser?.uid);
  useEffect(() => {
    const prev = prevUidRef.current;
    const curr = currentUser?.uid;
    if (prev && !curr) {
      disconnectStreamUser().catch((e) => console.error('[stream] disconnect failed', e));
    }
    prevUidRef.current = curr;
  }, [currentUser?.uid]);

  if (!streamClient) {
    return <div style={{ padding: 24, textAlign: 'center', opacity: 0.6 }}>Chat is not configured (REACT_APP_STREAM_API_KEY missing).</div>;
  }
  if (state !== 'connected') {
    return <div style={{ padding: 24, textAlign: 'center', opacity: 0.6 }}>Connecting to chat...</div>;
  }
  return <Chat client={streamClient}>{children}</Chat>;
};
